<template>
  <div class="RightNavigation">
    <div v-show="displayMode === 'PERSONDATA'" style="height:100%;">
        <h4 class="Navigation_head">
            <a class="Navigation_close" v-on:click="closeDisplay"></a>
            <span class="Navigation_arrow"></span>
            <p>User Layer</p>
        </h4>
        <transition name="list">
            <div id="personal_layer" class="r_nav_group blue_link scroll_box_b scollbarY" style="height: 95%; overflow-y: auto;" tabindex="1">
                    <dl class="UserLayer_group f_checkbox" v-bind:class="{ click_show: isShowAirPackageList }"><dt v-on:click="isShowAirPackageList = !isShowAirPackageList">AirPackage</dt>
                        <dd v-show="isShowAirPackageList" v-for="(item, index) in userInfo.layerData" v-bind:key="index">
                            <p v-if="item.type === 'AirPackage'"  v-on:click="setPersonLayerStatus(item, '')" v-bind:class="{active: allPersonLayerStatus[item.name]&&allPersonLayerStatus[item.name].status=='show'}">
                                <a class="round_layer">
                                    <span class="UserLayer e_3"></span>
                                    {{ item.name }}
                                </a>
                            </p>
                        </dd>
                    </dl>
                    <dl class="UserLayer_group f_checkbox" v-bind:class="{ click_show: isShow3DtilesList }"><dt v-on:click="isShow3DtilesList = !isShow3DtilesList">3DTiles</dt>
                        <!--<transition name="list">-->
                            <dd v-show="isShow3DtilesList" v-for="(item, index) in userInfo.layerData" v-bind:key="index">
                                <p v-if="item.type === '3dtile'"  v-on:click="setPersonLayerStatus(item, '')" v-bind:class="{active: allPersonLayerStatus[item.name]&&allPersonLayerStatus[item.name].status=='show'}">
                                    <a class="round_layer">
                                        <span class="UserLayer e_2"></span>
                                        {{ item.name }}
                                    </a>
                                </p>
                            </dd>
                        <!--</transition>-->
                    </dl>
                    <dl class="UserLayer_group f_checkbox" v-bind:class="{ click_show: isShowCZMLList }"><dt v-on:click="isShowCZMLList = !isShowCZMLList">CZML</dt>
                        <dd v-show="isShowCZMLList" v-for="(item, index) in userInfo.layerData" v-bind:key="index">
                            <p v-if="item.type === 'czml'" v-on:click="setPersonLayerStatus(item, '')" v-bind:class="{active: allPersonLayerStatus[item.name]&&allPersonLayerStatus[item.name].status=='show'}">
                                <a class="round_layer">
                                    <span class="UserLayer e_1"></span>
                                    {{ item.name }}
                                </a>
                            </p>
                        </dd>
                    </dl>
                    <dl class="UserLayer_group f_checkbox" v-bind:class="{ click_show: isShowGeoJsonList }"><dt v-on:click="isShowGeoJsonList = !isShowGeoJsonList">GEO</dt>
                        <dd v-show="isShowGeoJsonList" v-for="(item, index) in userInfo.layerData" v-bind:key="index">
                            <p v-if="item.type === 'AirGeoJson'" v-on:click="setPersonLayerStatus(item, '')" v-bind:class="{active: allPersonLayerStatus[item.name]&&allPersonLayerStatus[item.name].status=='show'}">
                                <a class="round_layer">
                                    <span class="UserLayer e_4"></span>
                                    {{ item.name }}
                                </a>
                            </p>
                        </dd>
                    </dl>
                    <dl class="UserLayer_group f_radio" v-bind:class="{ click_show: isShowFlyList }"><dt v-on:click="isShowFlyList = !isShowFlyList">FLY</dt>
                        <dd v-show="isShowFlyList" v-for="(item, index) in userInfo.layerData" v-bind:key="index">
                            <p v-if="item.type === 'fly'" v-on:click="setPersonLayerStatus(item, '')" v-bind:class="{active: allPersonLayerStatus[item.name]&&allPersonLayerStatus[item.name].status=='show'}">
                                <a class="round_layer">
                                    <span class="UserLayer e_5"></span>
                                    {{ item.name }}
                                </a>
                            </p>
                        </dd>
                    </dl>
            </div>
        </transition>
    </div>
    <div v-show="displayMode === 'GLOBAlDATA'" style="height:100%;">
        <h4 class="Navigation_head">
            <a class="Navigation_close"  v-on:click="closeDisplay"></a>
            <span class="Navigation_arrow Navigation_global_arrow"></span>
            <p>Global Layer</p>
            <div class="scroll_box_b scollbarY" v-for="(item, index) in allGlobeLayers" v-bind:key="index">
                <ul id="globeLayer" class="r_map_group round_s_img click_li" v-for="(item_1, index_1) in item.layers" v-bind:key="index_1">
                    <li data-drive="WMTS_IMAGE" v-on:click="setGlobeLayerStatus(index_1, index)" v-bind:class="{active: item_1.cesiumData.isShow != 'false'}">
                        <a class="round_s">
                            <span class="f_w_text btn_r">{{item_1.name}}</span>
                            <img v-bind:src="item_1.dataProfile" alt="">
                        </a>
                    </li>
                </ul>
            </div>
        </h4>
    </div>
    <div v-show="displayMode === 'LEGEND'" style="height:100%;">
        <h4 class="Navigation_head">
            <a class="Navigation_close"  v-on:click="closeDisplay"></a>
            <span class="Navigation_arrow Navigation_legend_arrow"></span>
            <p>Modern Function</p>
            <modera-function></modera-function>
        </h4>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import ModeraFunction from '@/components/ModeraFunction'
  $(".UserLayer_group").siblings().slideToggle();
  export default {
    name: 'RightBar',
    props: {
        displayMode: {
            default: ''
        },
        userInfo: {
            default: ''
        }
    },
    watch: {
        'userInfo.isGuest' : {
            handler:function(val,oldval){
                // if(val = 'yes')
                {
                    this.allPersonLayerStatus = {};
                }
            },  
            deep:true
        }
    },
    data () {
      return {
        msg: 'This is RightNavigation1!',
        // displayMode: "PERSONDATA",
        isActive: false,
        allGlobeLayers: {
        },
        allGlobeLayerStatus: {
        },
        allPersonLayerStatus: {
        },
        isShowAirPackageList: true,
        isShow3DtilesList: false,
        isShowGeoJsonList: false,
        isShowCZMLList: false,
        isShowPlaceMarkList: false,
        isShowFlyList: false,
        imageLayerFlag: 0,
        imageLayerValuableCount: 1
      }
    },
    /*watch: {
        layerData: {
            handler:function(val,oldval){
                pfAirViewer._personLayerManager.initializeData(val);
            },  
            deep:true
        }
  },*/
    mounted: function() {
        this.$axios.get(
           "./static/globeLayer.json"
        ).then(this.updateGlobeInfo,this.errorHandle);
    },
    methods: {
        closeDisplay: function()
        {
            this.$emit('closeNav','');
        },
        setPersonLayerStatus: function(layer,value)
        {
            if(!this.allPersonLayerStatus[layer.name])
            {
                if(layer.type === "fly")
                {
                    for(var i in this.allPersonLayerStatus)
                    {
                        if(this.allPersonLayerStatus[i].type === "fly")
                        {
                            this.allPersonLayerStatus[i].status = "hide";
                        }
                    }
                }
                this.$set(this.allPersonLayerStatus,layer.name,{
                    status: "show",
                    type: layer.type
                });
            }else{
                if(this.allPersonLayerStatus[layer.name].status === "hide")
                {
                    if(layer.type === "fly")
                    {
                        for(var i in this.allPersonLayerStatus)
                        {
                            if(this.allPersonLayerStatus[i].type === "fly")
                            {
                                this.allPersonLayerStatus[i].status = "hide";
                            }
                        }
                    }
                    this.allPersonLayerStatus[layer.name].status = "show";
                    
                }else{
                    this.allPersonLayerStatus[layer.name].status = "hide";
                }
            }
            pfAirViewer._personLayerManager.processDataStatus(layer.name);
        },
        updateGlobeInfo: function(globeInfo){
            var layers = pfAirViewer.scene.imageryLayers;
            this.allGlobeLayers = globeInfo.data;
            //console.log(this.allGlobeLayers);
            for(var i in this.allGlobeLayers){
                if(this.allGlobeLayers[i].category === "WMTS_IMAGE"){
                    var imageLayers = this.allGlobeLayers[i].layers;
                    imageLayers.sort(function(aValue,bValue){
                        aValue.indexOverlay = Cesium.defaultValue(aValue.indexOverlay, 1);
                        bValue.indexOverlay = Cesium.defaultValue(bValue.indexOverlay, 1);
                        return parseInt(aValue.indexOverlay)-parseInt(bValue.indexOverlay);
                    });
                    for(var j in imageLayers){
                        var imageProvider = new Cesium[imageLayers[j].cesiumData.dataType](imageLayers[j].cesiumData.options);
                        if(!Cesium.defined(imageLayers[j].cesiumData.layerOptions)){
                            imageLayers[j].cesiumData.layerOptions = {};
                        }
                        var imageLayer = new Cesium.ImageryLayer(imageProvider, imageLayers[j].cesiumData.layerOptions);
                        layers.add(imageLayer);
                        imageLayer.defaultAlpha = imageLayers[j].cesiumData.defaultAlpha;
                        imageLayer.show = (imageLayers[j].cesiumData.isShow === "true") ? true : false;
                        imageLayers[j].indexOverLay = layers.length-1;
                        //console.log(layers);
                    }
                }else if(this.allGlobeLayers[i].category === "WMTS_TERRAIN"){
                    var terrainLayers = this.allGlobeLayers[i].layers;
                    for(var j in terrainLayers){
                        if(terrainLayers[j].cesiumData.isShow === "true"){
                            pfAirViewer.terrainProvider = new Cesium[terrainLayers[j].cesiumData.dataType](terrainLayers[j].cesiumData.options);
                        }
                    }
                }
                //this.allGlobeLayers[i].layers;
            }
        },
        setGlobeLayerStatus: function(layerIndex,categoryIndex) {
            //debugger;
            var globeLayerJson = this.allGlobeLayers[categoryIndex].layers[layerIndex];
            var layerCategory = this.allGlobeLayers[categoryIndex].category;
            if(layerCategory === "WMTS_IMAGE"){
                if(globeLayerJson.cesiumData.isShow === "true"){
                    pfAirViewer.scene.imageryLayers.get(globeLayerJson.indexOverLay).show = false;
                    globeLayerJson.cesiumData.isShow = "false";
                }else{
                    pfAirViewer.scene.imageryLayers.get(globeLayerJson.indexOverLay).show = true;
                    globeLayerJson.cesiumData.isShow = "true";
                }
            }else if(layerCategory === "WMTS_TERRAIN"){
                if(globeLayerJson.cesiumData.isShow === "true"){
                    //pfAirViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                    pfAirViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                    globeLayerJson.cesiumData.isShow = "false";
                }else{
                    pfAirViewer.terrainProvider = new Cesium[globeLayerJson.cesiumData.dataType](globeLayerJson.cesiumData.options);
                    globeLayerJson.cesiumData.isShow = "true";
                }
            }
            console.log(globeLayerJson);
            console.log(this.allGlobeLayers);
            /*if(!this.allGlobeLayerStatus[globeLayerJson.id]) // loading
            {
                // this.$set(this.allGlobeLayerStatus,layerName,"show");
                if(globeLayerJson.type === "WMTS_IMAGE")
                {
                    this.imageLayerFlag++;
                    this.$set(this.allGlobeLayerStatus,globeLayerJson.id,{
                        status: "new",
                        index: this.imageLayerFlag
                    });
                }
                else{
                    this.$set(this.allGlobeLayerStatus,globeLayerJson.id,{
                        status: "new",
                        index: -1
                    });
                }
            }else{
                if(this.allGlobeLayerStatus[globeLayerJson.id].status === "hide")
                {
                    this.allGlobeLayerStatus[globeLayerJson.id].status = "show";
                }else{
                    this.allGlobeLayerStatus[globeLayerJson.id].status = "hide";
                }
            }
            this.setRealGolbeLayerStatus(globeLayerJson, this.allGlobeLayerStatus[globeLayerJson.id].status);*/
        },
        setRealGolbeLayerStatus: function(layerJson,layerStatus) {
            var layers = pfAirViewer.scene.imageryLayers;
            if(layerStatus === "new")
            {
                if(Cesium[layerJson.cesiumData.dataType])
                {
                    if(layerJson.type === "WMTS_TERRAIN") //terrain
                    {
                        pfAirViewer.terrainProvider = new Cesium[layerJson.cesiumData.dataType](layerJson.cesiumData.options);
                    }else if(layerJson.type === "WMTS_IMAGE"){
                        //layers.removeAll();
                        this.imageLayerValuableCount++;
                        var imageLayer = new Cesium[layerJson.cesiumData.dataType](layerJson.cesiumData.options);
                        imageLayer.defaultAlpha = layerJson.cesiumData.defaultAlpha;
                        layers.addImageryProvider(imageLayer);
                        //layers.get(0).show = false;
                    }
                }
            }else if(layerStatus === "show"){
                if(layerJson.type === "WMTS_TERRAIN") //terrain
                {
                    pfAirViewer.terrainProvider = new Cesium[layerJson.cesiumData.dataType](layerJson.cesiumData.options);
                }else if(layerJson.type === "WMTS_IMAGE"){
                    this.imageLayerValuableCount++;
                    layers.get(this.allGlobeLayerStatus[layerJson.id].index).show = true;
                    layers.get(0).show = false;
                }
            }else if(layerStatus === "hide"){
                if(layerJson.type === "WMTS_TERRAIN") //terrain
                {
                    pfAirViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                }else if(layerJson.type === "WMTS_IMAGE"){
                    this.imageLayerValuableCount--;
                    layers.get(this.allGlobeLayerStatus[layerJson.id].index).show = false;
                    if(this.imageLayerValuableCount === 1)
                    {
                        layers.get(0).show = true;
                    }
                }
            }else{
                console.log("LayerStatus error!");
            }
        },
        errorHandle: function(info){
            console.log(info);
        },
    },
    components: {
        ModeraFunction
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.RightNavigation{
    height:100%;
}
.Navigation_head{
    border-bottom:1px solid #e0e0e0;
    height: 5%;
    line-height:40px;
    cursor: pointer;
    color:#0d5881; font-size:14px; 
    font-weight:normal; 
    margin:0 0;
}
.Navigation_close{ 
    float:right; 
    width:40px; 
    height:100%; 
    cursor:pointer; 
    background:url('../../static/images/icon/close.png') no-repeat center center;
}
.Navigation_arrow{ 
    float:left; 
    width:40px; 
    height:100%; 
    overflow:hidden; 
    margin:0 0em; 
    background-image:url('../../static/images/icon/tool_arrow.png');
    background-repeat:no-repeat; 
    background-position:-40px top;
}
.Navigation_global_arrow{
    background-position: -40px -40px;
}
.Navigation_legend_arrow{
    background-position: -40px -80px;
}
.UserLayer_group{
    font-size: 14px;
    margin: 0;
    box-sizing: border-box;
}
.UserLayer_group dt {
    background-image: url('../../static/images/icon/add.png');
    background-position: 95% center;
    background-repeat: no-repeat;
    border-bottom: 1px solid #e0e0e0;
    color: #0d5881;
    cursor: pointer;
    font-weight: 400;
    line-height: 40px;
    padding-left: 1em;
}
.click_show dt {
    background-color: #0d5881;
    background-image: url('../../static/images/icon/negative.png');
    color: #fff;
}
.UserLayer_group dd {
    /*display: none;*/
    padding: 0 0.4em;
}
.UserLayer_group dd p {
    height: 46px;
    margin: 0.3em 0;
}
.UserLayer_group dd p a {
    background-color: #fff;
    display: block;
    height: 44px;
    line-height: 40px;
    padding: 3px 0;
    position: relative;
}
.UserLayer_group dd p *:hover {
    background-color: #e2e2e2;
    color: #333;
}
.UserLayer_group dd .active a {
    background-color: #0d5881;
    color: #fff;
}
.UserLayer_group dd p a::after {
    border-right: 1px solid #0d5881;
    border-top: 1px solid #0d5881;
    content: "";
    display: block;
    height: 7px;
    position: absolute;
    right: 1em;
    top: 1.5em;
    transform: rotate(45deg);
    width: 7px;
}
.UserLayer_group dd .active a::after {
    border-color: #fff;
}
.UserLayer{
    background-image: url('../../static/images/icon/tool_arrow.png');
    background-position: -80px top;
    background-repeat: no-repeat;
    float: left;
    height: 40px;
    margin: 0 0.6em 0 0.5em;
    overflow: hidden;
    width: 40px;
}
.round_layer {
    border-radius: 5px;
    cursor: pointer;
    text-decoration : none;
}
.e_2 {
    background-position: -80px -40px;
}
.e_3 {
    background-position: -80px -80px;
}
.e_4 {
    background-position: -80px -120px;
}
.e_5 {
    background-position: -80px -160px;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active, .list-leave-active {
  transition: all 3s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(60px);
}

/*globe layer css*/
.r_map_group {
  margin: 0 1em;
  padding: 0px;
}
.r_map_group li {
  margin: 0.5em 0;
  text-align: left;
}
.r_map_group li a {
  display: block;
  position: relative;
}
.r_map_group img {
  max-width: 100%;
}
.r_map_group .active a img {
  border: 3px solid #0d5881;
}
ul {
  list-style: outside none none;
}
ol, ul {
  margin-bottom: 10px;
  margin-top: 0;
}
.round_s, .round_s_img img {
  border-radius: 3px;
}
.btn_r {
  border-radius: 0 3px 3px 0;
}
.f_w_text {
  background-color: rgba(255, 255, 255, 0.6);
  color: #000;
  font-size: 14px;
  left: 2px;
  line-height: 1.8em;
  padding: 0 0.6em;
  position: absolute;
  top: 12%;
}


</style>


// WEBPACK FOOTER //
// src/components/RightNavigation.vue